// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductImage.module.scss  */
.ProductImage-module-Root_3xB {
  --border-width: 1px;
  --gradient: -webkit-linear-gradient(134.87deg, #dee1eb 13.37%, #dee1eb 87.55%);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  white-space: nowrap;
  border: solid var(--border-width) transparent;
  border-radius: 8px;
  background: white;
  background-clip: padding-box;
  aspect-ratio: 1/1; }
  .ProductImage-module-Root_3xB\\--gradientBorder {
    --gradient: -webkit-linear-gradient(134.87deg, #ff00d5 13.37%, #3aa8f2 87.55%); }
  .ProductImage-module-Root_3xB::before {
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: calc(var(--border-width) * -1);
    content: '';
    border-radius: inherit;
    background-image: var(--gradient); }

.ProductImage-module-Image_2EX {
  max-width: 100%;
  height: auto; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Image/ProductImage.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,8EAA8E;EAC9E,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB,EAAE;EACnB;IACE,8EAA8E,EAAE;EAClF;IACE,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,sCAAsC;IACtC,WAAW;IACX,sBAAsB;IACtB,iCAAiC,EAAE;;AAEvC;EACE,eAAe;EACf,YAAY,EAAE","sourcesContent":["/*  imported from ProductImage.module.scss  */\n.ProductImage-module-Root_3xB {\n  --border-width: 1px;\n  --gradient: -webkit-linear-gradient(134.87deg, #dee1eb 13.37%, #dee1eb 87.55%);\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  cursor: pointer;\n  white-space: nowrap;\n  border: solid var(--border-width) transparent;\n  border-radius: 8px;\n  background: white;\n  background-clip: padding-box;\n  aspect-ratio: 1/1; }\n  .ProductImage-module-Root_3xB\\--gradientBorder {\n    --gradient: -webkit-linear-gradient(134.87deg, #ff00d5 13.37%, #3aa8f2 87.55%); }\n  .ProductImage-module-Root_3xB::before {\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: calc(var(--border-width) * -1);\n    content: '';\n    border-radius: inherit;\n    background-image: var(--gradient); }\n\n.ProductImage-module-Image_2EX {\n  max-width: 100%;\n  height: auto; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
